import { render, staticRenderFns } from "./ParticipantsInfo.vue?vue&type=template&id=42d92008"
import script from "./ParticipantsInfo.vue?vue&type=script&lang=js"
export * from "./ParticipantsInfo.vue?vue&type=script&lang=js"
import style0 from "./ParticipantsInfo.vue?vue&type=style&index=0&id=42d92008&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports